// extracted by mini-css-extract-plugin
export var boxItems = "_8t-1";
export var boxItemsLg = "_8t-2";
export var button = "_8t-7";
export var buttonHoverless = "_8t-9";
export var buttonLg = "_8t-8";
export var filterGroupBox = "_8t-0";
export var icon = "_8t-3";
export var iconSecondary = "_8t-6";
export var iconWrapper = "_8t-4";
export var iconWrapperLg = "_8t-5";
export var truncatedLabel = "_8t-a";